<template>
  <oie-base-input-v2
    v-model="phoneNumber"
    v-bind="$attrs"
    :label="labelInput"
    :placeholder="placeholderInput"
    maxlength="27"
    :prefix="countryCode"
    :data-pw="playwright"
    v-on="$listeners"></oie-base-input-v2>
</template>

<script>
import utils from '@/core/utils'

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    countryCode: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Date],
      default: null
    },
    playwright: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      phoneNumber: ''
    }
  },
  computed: {
    labelInput() {
      return this.label ? this.label : this.tStatic('phoneLabel')
    },
    placeholderInput() {
      return this.placeholder ? this.placeholder : this.tStatic('phonePlaceholder')
    }
  },
  watch: {
    phoneNumber(newValue) {
      this.$emit('input', utils.savePhoneNumberWithFormating(newValue, this.countryCode))
    },
    countryCode(newValue) {
      this.$emit('input', utils.savePhoneNumberWithFormating(this.phoneNumber, newValue))
    }
  },
  beforeMount() {
    if(this.value) {
      this.phoneNumber = utils.extractPhoneNumberFromFormating(this.value, this.countryCode)
    }
  }

}
</script>

<style lang="scss">

</style>
